import React from "react";
import { motion } from "framer-motion";

/**
 * Text reveal char-by-char. Preserva spazi come blocchi vuoti.
 * Usa `once: true` in viewport per non ri-triggerare a scroll.
 */
export default function AnimatedHeading({ text, as: Tag = "h2", className = "", delay = 0, ...rest }) {
    const chars = Array.from(text);
    return (
        <Tag className={className} {...rest} aria-label={text}>
            <motion.span
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, margin: "-80px" }}
                transition={{ staggerChildren: 0.018, delayChildren: delay }}
                aria-hidden="true"
                style={{ display: "inline-block" }}
            >
                {chars.map((c, i) => (
                    c === " " ? (
                        <span key={i} className="lp-anim-space" />
                    ) : (
                        <motion.span
                            key={i}
                            className="lp-anim-char"
                            variants={{
                                hidden: { opacity: 0, y: 22 },
                                visible: {
                                    opacity: 1,
                                    y: 0,
                                    transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
                                },
                            }}
                        >
                            {c}
                        </motion.span>
                    )
                ))}
            </motion.span>
        </Tag>
    );
}
